<template>
	<div class="goods">
		<v-head :title="title"></v-head>
    <van-cell-group>
      <van-field
        v-model="base.title"
        center
        clearable
        placeholder="请输入主题"
      >
        <van-button slot="button" size="small" type="primary"  @click="search()">搜索</van-button>
      </van-field>
    </van-cell-group>
     <ul>
       <li v-for="(base,index) in list.content" :key="index">
         <h4>
          <span>【{{base.messageReceiver.readState===0?'未读':'已读'}}】</span>
         <p>{{base.messageInfo.title}}</p></h4>
         <div class="date"><span>日期：{{base.messageInfo.createTime | limitDate}}</span>
          <span>发件人：{{base.messageInfo.sender}}</span></div>
         <div class="contentc"><p>{{base.messageInfo.content}}</p></div>
         <div class="details"><span   @click="go('stationDetail',index)">详情</span>
          <span style="color: red; border-left: #ededed solid 1px" @click="del(index)">
          删除</span>
        </div>
       </li>
     </ul>
    <van-pagination 
      v-model="currentPage" 
      :page-count="list.totalPages"
      :total-items="list.numberOfElements"
      :items-per-page="1"
      @change="change"
      mode="simple" 
    />
    	</div>
</template>
<script>
import {
    queryMail,
    delMessageReceiver,
    downLoadFile,
    saveReceiver,
    unRead,
    getCheckMessage
} from "@/api/dictionary";
import { Field, Button,Toast,CellGroup,Dialog,Pagination } from "vant";
import vHead from "../../components/Subhead.vue";
import { mapGetters, mapState, mapMutations } from "vuex";
import { getSessionStore } from "@/utils/sessionStorage";
export default {
  data() {
    return {
     title:"站内信",
     list: [],
     base:{
      memberId:"",
      title:"",
      readState:"",
      sender:"",
      content:"",
     },
     currentPage:1,
    };
  },
  components: {
    vHead,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Pagination.name]: Pagination,
  },
  computed: {
      ...mapGetters(["commond", "isGroupMember"]),
      ...mapState(["userInfo"]),
  },
  methods: {
    go(pathName,index) {
        let params = {};
        params.infoId = this.list.content[index].messageInfo.id;
        if(this.list.content[index].messageReceiver.readState==0){
          this.list.content[index].messageReceiver.readState =1;
         saveReceiver(this.list.content[index].messageReceiver)
                  .then(res => {
                  })
        }
        this.$router.push({ name: pathName ,query:params});
    },
    getData() {
        this.base.memberId = this.memberId;
        queryMail(this.base, this.currentPage-1)
            .then(res => {
                if (res.success) {
                    this.list = res.result;   

                }
            })
            .catch(() => {
                Toast.fail("获取数据失败");
            });
    },
    search(){
        this.getData();
    },
    checkMessage(){
      if(this.memberId){
        getCheckMessage({memberId:this.memberId})
          .then(res => {
            this.getData();
          })
      }
    },
    del(index) {
      let params = {
        receiverId: this.list.content[index].messageReceiver.id
      };
      Dialog.confirm({
        title: '提示',
        message: '您确定要删除此条信息？'
      }).then(() => {
        delMessageReceiver(params)
                  .then(res => {
                    if (res.success) {
                      Toast.success("删除成功");
                      this.getData()
                    }
                  })
      }).catch(() => {
        Toast.fail("删除数据失败");
      });

    },
    change(page){
      this.page = page;
      this.getData();
    }
  },
mounted() {
  this.memberId = getSessionStore("memberId");
  this.checkMessage();
}
};
</script>

<style scoped>
body{ background:#fafafa; }
.goods ul li{ padding: 20px 0; border-bottom: #fafafa solid 10px; padding-bottom: 20px; }
.goods ul li h4{ font-size:16px; padding:0 3%;display: inline-flex; line-height: 30px; width: 94%}
.goods ul li h4 span{ width:18%; }
.goods ul li h4 p{line-height: 30px;width:82%;
text-overflow: -o-ellipsis-lastline;
overflow: hidden; 
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical; }
.goods ul li .date{ font-size:14px; margin: 15px 0; color: #888;padding:0 20px;}
.date span{ margin-right: 20px; }
.contentc{ padding:0 20px; }
.contentc p{ font-size:14px;line-height: 20px;
  text-overflow: -o-ellipsis-lastline;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical; }
.details{ text-align: center; margin-top: 15px; overflow: hidden;
  border-top:#ededed solid 1px; padding-top: 20px;}
.details span{ width: 49.8%; font-weight: normal; float: left; }
/deep/.van-cell--center{ border-bottom: #ededed solid 1px; }
</style>